import { render, staticRenderFns } from "./purchaseHistoryLists.vue?vue&type=template&id=46c3f013&scoped=true&"
import script from "./purchaseHistoryLists.vue?vue&type=script&lang=js&"
export * from "./purchaseHistoryLists.vue?vue&type=script&lang=js&"
import style0 from "./purchaseHistoryLists.vue?vue&type=style&index=0&id=46c3f013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3f013",
  null
  
)

export default component.exports